import "./CertificateGroupingTVOC.scss";
import CertificateGroupingListTVOC from "../../features/CertificateGroupingListTVOC/CertificateGroupingListTVOC";

const CertificateGroupingTVOC = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListTVOC />
    </div>
  );
};

export default CertificateGroupingTVOC;
